import React from 'react';
import { Star } from 'lucide-react';
const TestimonialsSection = () => {
  const testimonials = [{
    id: 1,
    name: 'Michael Johnson',
    role: 'Homeowner, Naples',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
    stars: 5,
    quote: 'The home theater system they installed exceeds all our expectations. The team was professional, knowledgeable, and left our home spotless. The sound quality is incredible!'
  }, {
    id: 2,
    name: 'Jennifer Williams',
    role: 'Restaurant Owner, Fort Myers',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
    stars: 5,
    quote: "Our restaurant's audio system has transformed the dining experience for our customers. The ability to control different zones independently is exactly what we needed."
  }, {
    id: 3,
    name: 'Robert Garcia',
    role: 'Office Manager, Cape Coral',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=687&q=80',
    stars: 5,
    quote: 'The network infrastructure they installed has eliminated all our connectivity issues. Our staff can now work efficiently without any WiFi dead zones or slowdowns.'
  }];
  const renderStars = (count: number) => {
    return Array(count).fill(0).map((_, i) => <Star key={i} className="w-5 h-5 fill-current text-yellow-400" data-id="element-322" data-mp="2h1a0jk254ta2" data-mpi={i} />);
  };
  return <section id="testimonials-section" className="py-16 md:py-24 bg-gray-50" data-id="element-323" data-mp="1af3c5no4pzw">
      <div className="container mx-auto px-4" data-id="element-324" data-mp="1ci3hiijbzic">
        <div className="text-center mb-16" data-id="element-325" data-mp="3sfx0r9p0nhdb">
          <p className="text-blue-600 font-semibold mb-2" data-id="element-326" data-mp="3sjb1yely1kj6">TESTIMONIALS</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-327" data-mp="3e8xc58b5r3k">
            What Our Clients Say
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto" data-id="element-328" data-mp="8c0tjbfzjzdk">
            Don't just take our word for it. Here's what our satisfied customers
            have to say about our services and solutions.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-329" data-mp="3gtouz4ll92yp">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white rounded-xl shadow-md p-6 md:p-8" data-id="element-330" data-mp="3lsi5qp9hqfv6">
              <div className="flex items-center mb-6" data-id="element-331" data-mp="3qr2y62ii3v92">
                <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover mr-4" data-id="element-332" data-mp="3vib7kyjtzgm8" />
                <div data-id="element-333" data-mp="332a8uowdwlnf">
                  <h3 className="font-bold text-lg" data-id="element-334" data-mp="331qufi5y0fe5">{testimonial.name}</h3>
                  <p className="text-gray-600 text-sm" data-id="element-335" data-mp="1k75qcstsujuh">{testimonial.role}</p>
                  <div className="flex mt-1" data-id="element-336" data-mp="1k51pkjr760yf">
                    {renderStars(testimonial.stars)}
                  </div>
                </div>
              </div>
              <blockquote className="text-gray-600 italic" data-id="element-337" data-mp="1b5epq2e4937h">
                "{testimonial.quote}"
              </blockquote>
            </div>)}
        </div>
        <div className="mt-16 bg-blue-600 rounded-xl shadow-lg p-8 md:p-12" data-id="element-338" data-mp="1181mdyh47g9o">
          <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-339" data-mp="11a4m5a82knrl">
            <div className="mb-6 md:mb-0" data-id="element-340" data-mp="wga1a3gqa2qx">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-341" data-mp="sfgfbfmuiy0o">
                Ready to upgrade your space?
              </h3>
              <p className="text-blue-100" data-id="element-342" data-mp="nigat95na3bo">
                Join our satisfied customers and experience the difference.
              </p>
            </div>
            <a href="#contact-form" className="bg-white hover:bg-gray-100 text-blue-600 font-bold py-3 px-8 rounded-lg transition-colors duration-300" data-id="element-343" data-mp="di79xi0pjtpy">
              Get Started Today
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default TestimonialsSection;